import * as React from 'react'

import { Box, Circle, Tag } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import { LeaveInfo } from 'modules/attendance/store/models/CalendarDay'

interface Props {
  leaveInfo: LeaveInfo
}

function LeavePill({ leaveInfo }: Props) {
  const leaveName = leaveInfo.name
  const leaveColor = leaveInfo.color
  const circle = <Circle color={leaveColor} />

  return (
    <Box flexDirection="row" paddingRight="s8">
      <Tag leftItem="circle" type={Tag.Types.grey} circle={circle}>
        {leaveName}
      </Tag>
    </Box>
  )
}

export default observer(LeavePill)
